import './style.css';
import { dom, icon } from "#root/lib/dom";
import { mockReply } from './mock';
import { getChartData, getOrganizations } from './service/api';
import { renderChart } from './components/chart-cards/render_chart';
import { animationDuration, cleanState, clearStateAppear, main } from '#root/lib/win';
import { loadLang } from './l10n';
import { params } from '#root/lib/params';
import { showPopup, hidePopup } from './components/bottom-popup';
import { dropdown } from './components/dropdown';
import { delayAction } from '#root/lib/delay_action';
import { patchCanvas2DContext } from '#root/dashboard/charts/lib/canvas';
loadLang();
patchCanvas2DContext();
let lastScrollAnimationTimestamp;
window.addEventListener("scroll", () => {
  if (lastScrollAnimationTimestamp && Date.now() - lastScrollAnimationTimestamp < 200) {
    return;
  }

  const header = document.querySelector(".header-subtitle");

  if (header.classList.contains("collapse")) {
    if (window.scrollY === 0) {
      header.classList.remove("collapse");
      lastScrollAnimationTimestamp = Date.now();
    }
  } else {
    if (window.scrollY > 0) {
      header.classList.add("collapse");
      lastScrollAnimationTimestamp = Date.now();
    }
  }
}, true);
let dataDate = new Date();
dataDate.setMonth(dataDate.getMonth() - 6);
const dataYear = dataDate.getFullYear();
const pages = {
  "chart": {
    title: "Дашборд",
    id: "dashboard",
    pages: [{
      name: "Справи щодо бізнесу",
      nameHtml: `Справи щодо бізнесу <small class="text-muted">(дані за ${dataYear})</small>`,
      titleHtml: `<span class="nowrap">Справи щодо бізнесу</span> <small class="text-muted">(дані за ${dataYear})</small>`,
      id: "key-indicators",
      icon: require("@Resources/images/icons/business.svg")
    }, {
      name: "СтопТиск",
      id: "stop-pressure",
      icon: require("@Resources/images/icons/stop.svg")
    }, {
      name: "Загальні відомості",
      id: "overall",
      icon: require("@Resources/images/icons/overview.svg")
    }, {
      name: "Строки",
      id: "terms",
      icon: require("@Resources/images/icons/terms.svg")
    }, {
      name: "Обшуки",
      id: "searches",
      icon: require("@Resources/images/icons/searches.svg")
    }, {
      name: "Забезпечення",
      title: "Заходи забезпечення кримінального провадження",
      id: "provision",
      icon: require("@Resources/images/icons/inventory.svg")
    }, // {
    //     name: "Клопотання",
    //     id: "petitions",
    //     icon: require("@Resources/images/icons/inquires.svg"),
    // },
    {
      name: "Клопотання - Відсторонення та обмеження",
      nameHtml: `Клопотання <small class="text-muted">Відсторонення та обмеження</small>`,
      titleHtml: `<span class="nowrap">Клопотання</span> <small class="text-muted">Відсторонення та обмеження</small>`,
      id: "petitions-dismissal",
      icon: require("@Resources/images/icons/inquires.svg")
    }, {
      name: "Клопотання - Експертизи",
      nameHtml: `Клопотання <small class="text-muted">Експертизи</small>`,
      titleHtml: `<span class="nowrap">Клопотання</span> <small class="text-muted">Експертизи</small>`,
      id: "petitions-expertise",
      icon: require("@Resources/images/icons/inquires.svg")
    }, {
      name: "Клопотання - Обшуки та арешти",
      nameHtml: `Клопотання <small class="text-muted">Обшуки та арешти</small>`,
      titleHtml: `<span class="nowrap">Клопотання</span> <small class="text-muted">Обшуки та арешти</small>`,
      id: "petitions-searches",
      icon: require("@Resources/images/icons/inquires.svg")
    }, {
      name: "Клопотання - Запобіжні заходи",
      nameHtml: `Клопотання <small class="text-muted">Запобіжні заходи</small>`,
      titleHtml: `<span class="nowrap">Клопотання</span> <small class="text-muted">Запобіжні заходи</small>`,
      id: "petitions-measures",
      icon: require("@Resources/images/icons/inquires.svg")
    }, {
      name: "Перша інстанція",
      id: "first-instance",
      icon: require("@Resources/images/icons/cassation.svg")
    }, {
      name: "Апеляція",
      title: "Апеляція",
      id: "appeal",
      icon: require("@Resources/images/icons/appeals.svg")
    }, {
      name: "Касація",
      id: "cassation",
      icon: require("@Resources/images/icons/cassation.svg")
    }]
  },
  "other": {
    title: "Інше",
    id: "other",
    pages: [{
      name: "Поширені питання",
      title: "Поширені питання",
      id: "faq",
      icon: require("@Resources/images/icons/help.svg")
    }]
  }
};
const chartPages = [];
let departmentFilters = [];
const timeFrameFilters = [{
  name: "1 м",
  id: "1m"
}, {
  name: "3 м",
  id: "3m"
}, {
  name: "6 м",
  id: "6m"
}, {
  name: "1 р",
  id: "12m"
}, {
  name: "Весь час",
  id: "all"
}];
let currentSectionId;
let currentDepartmentFilterIds = [""];
let currentArticleFilterIds = [];
let currentTimeFrameFilterId;
const USE_PATH_PARAM = false;
const dashboardSection = dom("div", {
  class: "section",
  children: []
});
const nav = dom("nav", {
  children: [dom("div", {
    class: "content",
    children: [dom("div", {
      class: "logo",
      children: icon(require("@Resources/images/icons/logo.svg")),

      onclick() {
        currentSectionId = "overall";
        pushState();
        renderPage();
      }

    }), dashboardSection, dom("div", {
      class: "sidebar-footer",
      html: `<a href="https://gp.gov.ua/ua/posts/podati-zvernennya" class="sidebar-button-secondary" target="_blank">${require("@Resources/images/icons/appeals.svg")} Подати звернення</a><a href="https://pulse.gov.ua/" class="sidebar-button-secondary" target="_blank">Зворотній звʼязок для бізнесу</a><br>Проєкт реалізується <a href="https://www.gp.gov.ua/" target="_blank">Офісом Генерального Прокурора</a> за підтримки <a href="https://thedigital.gov.ua/" target="_blank">Міністерства цифрової трансформації України</a> та координації <b>Ради з питань підтримки підприємництва в умовах воєнного стану</b>`
    })]
  })]
});

function renderNav() {
  dashboardSection.innerHTML = ""; // dashboardSection.appendChild(dom("h2", {
  //     children: [
  //         "Дашборд"
  //     ]
  // }));

  for (let group in pages) {
    const groupElement = dom("div", {
      class: "group",
      children: [dom("h2", {
        children: [pages[group].title]
      })]
    });
    dashboardSection.appendChild(groupElement);

    for (let filter of pages[group].pages) {
      const element = dom("div", {
        class: ["link", currentSectionId === filter.id ? "active" : ""],
        children: [icon(filter.icon), ...(filter.nameHtml ? [dom("div", {
          html: filter.nameHtml
        })] : [filter.name])]
      });
      element.addEventListener("click", () => {
        currentSectionId = filter.id;
        currentArticleFilterIds = [];
        currentDepartmentFilterIds = [""];
        pushState();
        renderPage();
      });
      groupElement.appendChild(element);
    }
  } // for (let filter of chartPages) {
  //     const element = dom("div", {
  //         class: ["link", currentSectionId === filter.id ? "active" : ""],
  //         children: [
  //             icon(filter.icon),
  //             filter.name
  //         ]
  //     });
  //     element.addEventListener("click", () => {
  //         currentSectionId = filter.id;
  //         currentArticleFilterIds = [];
  //         currentDepartmentFilterIds = [""];
  //         pushState();
  //         renderPage();
  //     });
  //     dashboardSection.appendChild(
  //         element
  //     )
  // }

}

document.body.innerHTML = "";
let serverDataOverwrite = mockReply;
let useOverwrite = false;

if (process.env.DEBUG) {
  if (params.useMock) {
    useOverwrite = true;
  }

  if (params.useStopPressureMock) {
    serverDataOverwrite = require("./mock_stoppressure").mockStopPressure;
    useOverwrite = true;
  }
}

const badgeAlpha = dom("div", {
  class: "badge-alpha",
  children: ["альфа-версія"]
}); // badgeAlpha.addEventListener("mouseenter", async () => {
//     showPopup().textContent = `///`;
// });
// badgeAlpha.addEventListener("mouseleave", () => {
//     hidePopup();
// });

const bodyContainer = dom("div", {
  class: "body-container",
  children: [nav, dom("div", {
    class: "main-container",
    children: [dom("header", {
      class: "header",
      children: [dom("div", {
        class: "header-block",
        children: [dom("h1", {
          children: [dom("div", {
            class: "mobile-menu",
            children: icon(require("@Resources/images/icons/menu.svg")),
            onclick: () => {
              document.querySelector("nav").classList.add("open");

              function onClose(e) {
                if (!e.target.closest("nav")) {
                  document.querySelector("nav").classList.remove("open");
                  document.body.removeEventListener("click", onClose);
                }
              }

              document.body.addEventListener("click", onClose, true);
            }
          }), "Дашборд", badgeAlpha]
        }), dom("div", {
          class: "header-subtitle",
          children: [dom("div", {
            children: [dom("p", {
              id: "page-header-subtitle",
              children: ["Статистика розслідування і розгляду в судах кримінальних правопорушень, які пов’язані із здійсненням господарської та інвестиційної діяльності"]
            }), dom("p", {
              class: "page-header-description",
              children: [`Ми працюємо над тим, аби максимально точно виокремити саме ці види кримінальних правопорушень. Наразі в альфа-версії дашборду вони визначені як кримінальні правопорушення, передбачені такими статтями КК України: 110, 110-2, 111, 111-1, 162, 172, 175–177, 182, 188-1, 189–192, 194, 197-1, 199–236, 239, 241–243, 246, 254, 255, 258-5, 270–273, 275, 289, 292, 298, 301–301-2, 319, 320, 332, 333, 355–358, 361, 362, 364-1, 365-2, 367, 368-3, 369, 369-2, 382, 384, 388, 441.`]
            })]
          })]
        })]
      }) // (process.env.DEBUG || process.env.STAGE) ? dom("button", {
      //     class: "button",
      //     children: [
      //         icon(require("@Resources/images/icons/dev.svg")),
      //         "Import JSON"
      //     ],
      //     onclick: importJsonView,
      // }) : null,
      ]
    }), main]
  })]
});
document.body.appendChild(bodyContainer); // let cachedDropdown;
// let articlesListCache;

let primaryPageContent;

const getCurrentSection = currentSectionId => {
  let section;

  for (let group in pages) {
    section = pages[group].pages.find(filter => filter.id === currentSectionId);

    if (section) {
      return {
        group,
        section
      };
    }
  }

  return {
    group: "chart",
    section: pages.chart.pages[0]
  };
};

async function renderPage(isPartialRefresh = false) {
  const {
    section: currentSection,
    group: currentGroup
  } = getCurrentSection(currentSectionId);
  const currentTimeFrameFilter = timeFrameFilters.find(filter => filter.id === currentTimeFrameFilterId);
  let data;

  try {
    if (currentSectionId === "faq") {
      await clearStateAppear(async () => {
        renderNav();
        const {
          renderHelp
        } = await import("#root/dashboard/pages/other/help.js");
        const helpPage = await renderHelp();
        buildTitleBar(false);
        main.appendChild(helpPage); // main.innerHTML = "121323";
      });
      return;
    }

    const subtitleElement = document.getElementById("page-header-subtitle");
    const descriptionElement = document.querySelector(".page-header-description");
    const subtitleDefault = "Статистика розслідування і розгляду в судах кримінальних правопорушень, які пов’язані із здійсненням господарської та інвестиційної діяльності";
    const descriptionDefault = `Ми працюємо над тим, аби максимально точно виокремити саме ці види кримінальних правопорушень. Наразі в альфа-версії дашборду вони визначені як кримінальні правопорушення, передбачені такими статтями КК України: 110, 110-2, 111, 111-1, 162, 172, 175–177, 182, 188-1, 189–192, 194, 197-1, 199–236, 239, 241–243, 246, 254, 255, 258-5, 270–273, 275, 289, 292, 298, 301–301-2, 319, 320, 332, 333, 355–358, 361, 362, 364-1, 365-2, 367, 368-3, 369, 369-2, 382, 384, 388, 441.`;

    if (currentSection.id === "key-indicators") {
      descriptionElement.textContent = `Вибірка в даному розділі сформована з кримінальних правопорушень, де надається кримінально-правова оцінка діяльності компаній або їх посадових/службових осіб, або де такі компанії чи особи є потерпілими, порушені їх права та інтереси чи розслідується посягання на порядок господарської та інвестиційної діяльності (в межах статей ККУ, зазначених в розділі «Загальні відомості»). В інших розділах ви можете побачити для порівняння всі кримінальні правопорушення за відповідними статтям кримінального кодексу, частина яких може не стосуватись саме господарської та інвестиційної діяльності.`;
      subtitleElement.textContent = subtitleDefault;
    } else if (currentSection.id === "stop-pressure") {
      subtitleElement.textContent = `Надходження повідомлень на портал "СтопТиск" та результати їх розгляду`;
      descriptionElement.textContent = '';
    } else {
      subtitleElement.textContent = subtitleDefault;
      descriptionElement.textContent = descriptionDefault;
    } // if (currentSection.id === "key-indicators" && !["1m", "3m", "6m"].includes(currentTimeFrameFilterId)) {
    //     currentTimeFrameFilterId = "6m";
    // }


    if (!isPartialRefresh) {
      await cleanState(async () => {
        renderNav();
        await fetchData();
      });
    } else {
      primaryPageContent.style.opacity = "0.5";
      primaryPageContent.style.pointerEvents = "none";
      await fetchData();
    }
  } catch (e) {
    main.innerHTML = "";
    main.appendChild(dom("div", {
      class: "error",
      children: [dom("h3", {
        textContent: "Помилка"
      }), dom("p", {
        textContent: e.message
      })]
    }));
    console.error(e);
    return;
  }

  async function fetchData() {
    if (useOverwrite) {
      data = serverDataOverwrite;
    } else {
      const to = new Date();
      let from = new Date(); // if (currentTimeFrameFilterId === "1month") {
      //     from.setMonth(to.getMonth() - 1);
      // } else if (currentTimeFrameFilterId === "3month") {
      //     from.setMonth(to.getMonth() - 3);
      // } else if (currentTimeFrameFilterId === "6month") {
      //     from.setMonth(to.getMonth() - 6);
      // } else if (currentTimeFrameFilterId === "1year") {
      //     from.setFullYear(to.getFullYear() - 1);
      // } else if (currentTimeFrameFilterId === "all") {
      //     from = null;
      // }

      if (currentSection.id === "key-indicators") {
        data = await getChartData(currentSection.id, currentDepartmentFilterIds, {
          period: currentTimeFrameFilterId,
          articles: []
        });
      } else {
        data = await getChartData(currentSection.id, currentDepartmentFilterIds, {
          period: currentTimeFrameFilterId,
          articles: currentArticleFilterIds
        });
      }

      departmentFilters = data.organizations ?? [];
    }
  }

  async function buildTitleBar(showFilters = true) {
    const pageTitlePanel = dom("div", {
      class: "page-title-panel",
      children: [dom("h2", {
        children: [icon(currentSection.icon), ...(currentSection.titleHtml ? [dom("div", {
          html: currentSection.titleHtml
        })] : [currentSection.title || currentSection.name])]
      }), ...(showFilters ? [dom("div", {
        class: "chip-selector-box",
        children: [departmentFilters.length > 1 ? dom("div", {
          class: "chip-selector",
          children: departmentFilters.map(departmentFilter => {
            return dom("div", {
              class: ["link", currentDepartmentFilterIds.includes(departmentFilter.name) ? "active" : ""],
              children: departmentFilter.presentation,
              onclick: e => {
                /*if (e.ctrlKey || e.metaKey) {
                    e.preventDefault();
                    if (departmentFilter.name === "") {
                        currentDepartmentFilterIds = departmentFilters.map(f => f.name).filter(f => f !== "");
                    } else {
                        if (currentDepartmentFilterIds.includes(departmentFilter.name)) {
                            currentDepartmentFilterIds = currentDepartmentFilterIds.filter(id => id !== departmentFilter.name);
                            if (currentDepartmentFilterIds.length === 0) {
                                currentDepartmentFilterIds = [""];
                            }
                        } else {
                            currentDepartmentFilterIds.push(departmentFilter.name)
                            currentDepartmentFilterIds = currentDepartmentFilterIds.filter(f => f !== "");
                        }
                    }
                } else {*/
                currentDepartmentFilterIds = [departmentFilter.name];
                /*}*/

                pushState();
                renderPage();
              }
            });
          })
        }) : null, data.articles ? (() => {
          const currentArticleFilter = data.articles.filter(filter => currentArticleFilterIds.includes(filter.name));
          /*let articleListsEqual = false;
               if (articlesListCache && data.articles.length === articlesListCache.length) {
              articleListsEqual = data.articles.every((article, i) => article.name === articlesListCache[i].name);
          }
               if (articleListsEqual) {
              requestAnimationFrame(() => {
                  cachedDropdown.refocus();
              });
              return cachedDropdown;
          }
               articlesListCache = data.articles;
               cachedDropdown =*/

          return dom(dropdown(true, "Стаття", require("@Resources/images/icons/chevron-down.svg"), "Пошук", require("@Resources/images/icons/search-lg.svg"), data.articles.map(article => {
            return {
              label: article.presentation,
              value: article.name
            };
          }), currentArticleFilter.length > 0 ? currentArticleFilter.map(e => ({
            label: e.presentation,
            value: e.name
          })) : [], v => {
            currentArticleFilterIds = v ? v.map(e => e.value) : [];
            pushState();
            renderPage(true);
          }), {
            class: "article-selector"
          }); // return cachedDropdown;
        })() : null, dom("div", {
          class: "chip-selector period-selector",
          children: timeFrameFilters.map(timeFrame => {
            return dom("div", {
              attrs: {
                "data-timeframe": timeFrame?.id
              },
              class: ["link", currentTimeFrameFilterId === timeFrame.id ? "active" : ""],
              children: timeFrame.name,
              onclick: () => {
                currentTimeFrameFilterId = timeFrame.id;
                pushState();
                renderPage();
              }
            });
          })
        })]
      })] : [])]
    });
    main.appendChild(pageTitlePanel);
  }

  async function buildPage() {
    primaryPageContent.innerHTML = "";
    main.appendChild(primaryPageContent);
    main.dataset.section = currentSectionId;

    if (!("charts" in data)) {
      primaryPageContent.appendChild(dom("div", {
        class: "empty-page-placeholder",
        children: "Дані на цій сторінці відсутні, але з'являться згодом"
      }));
      return;
    }

    const currentDepartmentFilter = departmentFilters.find(filter => currentDepartmentFilterIds.includes(filter.name));
    primaryPageContent.appendChild(dom("h3", {
      class: "section-title",
      children: currentDepartmentFilter ? currentDepartmentFilter.description : ""
    }));

    if (currentDepartmentFilterIds.includes("NABU")) {
      primaryPageContent.appendChild(dom("p", {
        class: "department-warning",
        children: [dom("b", {
          textContent: "Застереження!"
        }), ` Інформація зазначена на аналітичній платформі (в дашборді) формується на основі обліку кримінальних правопорушень, а тому відрізняється від інформації, відображеної у звітності про роботу органів досудового розслідування Національного антикорупційного бюро України (передбаченої Наказом Офісу Генерального прокурора, Міністерства внутрішніх справ України, Служби безпеки України, Державної фіскальної служби України, Державного бюро розслідувань, Національного антикорупційного бюро України від 28.07.2020 №  337/564/206/123/363/85 «Про затвердження форм звітності про роботу органів досудового розслідування») та звітах про діяльність Національного антикорупційного бюро (передбачених ст. 26 Закону України «Про Національне антикорупційне бюро України»), які формуються на основі обліку кримінальних проваджень.`]
      }));
    }

    const chartPrimaryContainer = dom("div", {
      class: "chart-primary-container"
    });
    primaryPageContent.appendChild(chartPrimaryContainer);

    for (let chartRow of data.charts) {
      const chartRowContainer = dom("div", {
        class: "chart-row-container"
      });
      chartPrimaryContainer.appendChild(chartRowContainer);

      for (let chart of chartRow.charts) {
        // Build context for CSV export
        const exportContext = {
          section: currentSection.id,
          department: currentDepartmentFilterIds.filter(id => id !== "").join(","),
          article: currentArticleFilterIds.filter(id => id !== ""),
          period: currentTimeFrameFilterId
        };
        chartRowContainer.appendChild(renderChart(chart, exportContext));
      }
    }
  }

  ;

  if (isPartialRefresh) {
    setTimeout(() => {
      delayAction(async () => {
        try {
          primaryPageContent.innerHTML = "";
          await buildPage();
          delayAction(() => {
            primaryPageContent.style.opacity = "";
            primaryPageContent.style.pointerEvents = "";
          });
        } catch (e) {
          main.innerHTML = "";
          main.appendChild(dom("div", {
            class: "error",
            children: [dom("h3", {
              textContent: "Помилка"
            }), dom("p", {
              textContent: e.message
            })]
          }));
          console.error(e);
        }
      });
    }, animationDuration());
  } else {
    await clearStateAppear(async () => {
      primaryPageContent = dom("div", {
        class: "primary-page-content"
      });
      await buildTitleBar();
      await buildPage();
    });
  }
}

async function init() {
  main.innerHTML = "";
  main.appendChild(dom("div", {
    class: "loader-container",
    children: [dom("div", {
      class: "loader"
    })]
  })); // departmentFilters = (await getOrganizations()).list;

  const url = new URL(window.location.href);
  const path = url.pathname.replace(/\/$/, ""); // Remove trailing slash

  if (USE_PATH_PARAM && path === "/faq") {
    currentSectionId = "faq";
  } else {
    currentSectionId = params.section ?? pages.chart.pages[0].id;
  }

  currentDepartmentFilterIds = (params.department ?? "").split(",");
  currentArticleFilterIds = (params.article ?? "").split(",");
  currentTimeFrameFilterId = params.period ?? "all";
  window.addEventListener("popstate", () => {
    const url = new URL(window.location.href);
    const path = url.pathname.replace(/\/$/, ""); // Remove trailing slash

    if (USE_PATH_PARAM && path === "/faq") {
      currentSectionId = "faq";
    } else {
      const params = new URLSearchParams(window.location.search);
      currentSectionId = params.get("section") ?? pages.chart.pages[0].id; // const allPageIds = [
      //     ...pages.chart.pages.map(page => page.id),
      //     ...pages.other.pages.map(page => page.id),
      // ];
      // console.log("ALL PAGE IDS", allPageIds, currentSectionId);
      // if (!allPageIds.includes(currentSectionId)) {
      //     currentSectionId = "overall";
      // }

      currentDepartmentFilterIds = params.get("department").split(",") ?? [""];
      currentArticleFilterIds = params.get("article").split(",") ?? [];
      currentTimeFrameFilterId = params.get("period") ?? "all";
    }

    renderPage();
  }, true);
  renderPage();
}

init();

function pushState() {
  if (USE_PATH_PARAM) {
    if (currentSectionId === "faq") {
      window.history.pushState({}, "", "/faq");
      return;
    }
  }

  const params = new URLSearchParams();
  params.set("section", currentSectionId);
  params.set("department", currentDepartmentFilterIds.join(","));
  params.set("article", currentArticleFilterIds.join(","));
  params.set("period", currentTimeFrameFilterId);
  window.history.pushState({}, "", "?" + params.toString());
}

async function importJsonView() {
  await cleanState();
  await clearStateAppear();
  const title = dom("h3", {
    class: "section-title",
    children: "Import JSON"
  });
  main.appendChild(title);
  const textarea = dom("textarea", {
    class: "textarea",
    placeholder: "Paste JSON here",
    style: {
      width: "100%",
      fontFamily: "monospace",
      marginTop: "24px"
    },
    rows: 30
  });
  textarea.value = JSON.stringify(serverDataOverwrite, null, 4);
  main.appendChild(textarea);
  const button = dom("button", {
    class: "button",
    children: "Import",
    onclick: () => {
      try {
        serverDataOverwrite = JSON.parse(textarea.value);
        useOverwrite = true;
        renderPage();
      } catch (e) {
        alert("Invalid JSON");
      }
    }
  });
  main.appendChild(button);
  const fileInput = dom("input", {
    class: "button",
    type: "file",
    accept: ".json",
    onchange: e => {
      const file = e.target.files[0];
      const reader = new FileReader();

      reader.onload = function (e) {
        serverDataOverwrite = JSON.parse(e.target.result);
        useOverwrite = true;
        renderPage();
      };

      reader.readAsText(file);
    }
  });
  main.appendChild(fileInput);
}